import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics component
// Replace 'G-XXXXXXXXXX' with your actual GA4 Measurement ID
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

const GoogleAnalytics = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (!GA_MEASUREMENT_ID) {
      console.log('Google Analytics: Measurement ID not configured');
      return;
    }
    
    // Initialize GA4
    if (!window.gtag) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      script.async = true;
      document.head.appendChild(script);
      
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', GA_MEASUREMENT_ID);
    }
  }, []);
  
  useEffect(() => {
    if (window.gtag && GA_MEASUREMENT_ID) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
  
  return null;
};

export default GoogleAnalytics;
